<template>
  <div>
    <div class="loader" :class="[classes, { 'is-active': loading }]">
      <div class="position-absolute d-block"></div>
      <div class="position-absolute d-block"></div>
      <div class="position-absolute d-block"></div>
      <div class="position-absolute d-block"></div>
    </div>

    <p v-if="message" v-html="message" class="loader-text"></p>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: true
    },
    classes: {
      type: String,
      required: false
    },
    message: {
      type: String,
      required: false,
    }
  }
}
</script>
